import { IPartType } from "@drone-parts.garphild.pro/interfaces";
import { Button, Flex, Table } from "antd";

interface IPartTypeDetailsTableProps {
  partTypes: IPartType[];
  path?: string[];
}

function PartTypeDetailsTable({ path, partTypes }: IPartTypeDetailsTableProps) {
  return (
    <Table
      columns={[
        {
          title: 'Id',
          dataIndex: 'key',
          key: 'key',
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Actions',
          dataIndex: 'actions',
          key: 'actions',
          render: (pt: IPartType) => (
            <Flex>
              <Button onClick={() => {}}>Delete</Button>
              <Button onClick={() => {}}>Add</Button>
            </Flex>
          ),
        },
      ]}
      dataSource={partTypes || []}
      rowKey="_id"
    />
  );
}

export default PartTypeDetailsTable;
